<section class="page-back">
  <!-- start banner Area -->

  <section class="top-banner">
    <div class="top-banner-img" style="">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h1 style="padding: 30px 0px 0px 0px !important;"> Les entreprises</h1>
            <p class="text-white link-nav"><a routerLink="/admin" style="color: #ff5a00 !important">Accueil </a> <span
                class="lnr lnr-arrow-right"></span>
              <a routerLink="/admin/entreprises" style="color: white;"> Les entreprises</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <br> <br>

  <!-- End banner Area -->

  <!-- Start post Area -->
  <section class="post-area section-gap">
    <div class="container">

      <!-- Nb record find -->
      <div class="row d-flex justify-content-center mb-4">
        <span style="color: green">{{ companiesList.length }} enregistrement (s) trouvé(s)</span>
      </div>
      <!-- <div class="card row mb-10">
        <div class="card-body">
          <table class="table table-bordered">
            <tr>
              <th>Logo</th>
              <th>Nom complète </th>
              <th>Acronyme </th>
              <th>Nombre de personne</th>
              <th>Adresse</th>
              <th>Offres</th>
              <th>Actions</th>
            </tr>
            <tr *ngFor="let company of companiesList">
              <td><img src="/{{company.getLogo()}}" width="20" alt=""> </td>
              <td>{{ company.getName() }}</td>
              <td>{{ company.getAcronym() }}</td>
              <td>{{ company.getNbPerson() }}</td>
              <td>{{ company.getCity() }}, {{ company.getCountry() }}</td>
              <td><a routerLink="/admin/offres-emploi/{{ company.getId() }}" style="color: #3f3f8e;">{{
                  company.getNbJobs() }} offres d'emploi</a></td>
              <td>-</td>
            </tr>
          </table>
        </div>
      </div> -->
      <div class="row justify-content-center d-flex">
        <div class="col-lg-6 post-list mb-2" *ngFor="let company of companiesList">
          <div class="offre-list-card">
            <div class="">
              <img src="{{baseURL + company.getLogo()}}" width="110" style="height: 90%;" alt="">
            </div>
            <div class="details-offre">
              <p class="nom-entreprise"><span>
                  {{ company.getAcronym() }} </span></p>
              <p class="poste-offre"> {{ company.getName() }} </p>
              <p style="font-size: 14px;">Nombre de personne: {{ company.getNbPerson() }}</p>
              <div class="infos-offre">
                <p><img src=""> <span class="lnr lnr-license"></span> <span> </span>
                </p>
                <p><img src="assets/img/lieu.svg"> Adresse: {{ company.getCity() }}, {{ company.getCountry() }}</p>
                <h5> <a routerLink="/admin/offres-emploi/{{ company.getId() }}" style="color: #3f3f8e;">{{
                    company.getNbJobs() }} offres d'emploi</a></h5>
              </div>
            </div>
          </div>
          <!-- 
          <div class="single-post d-flex flex-row w-100">
            <div class="thumb mr-4">
              <img src="assets/img/" alt="" class="company-logo">
            </div>
            <div class="details">
              <div class="title d-flex flex-row justify-content-between">
                <div class="titles">
                  <a routerLink="/admin/offres-emploi/{{ company.getId() }}">
                    <h4 class="title-ellipsis">{{ company.getName() }}</h4>
                  </a>
                  <h6>{{ company.getAcronym() }}</h6>
                </div>
              </div>
              <p class="address title-ellipsis"><span class="lnr lnr-apartment"></span> Informatique & Télécom</p>
              <p class="address"><span class="lnr lnr-users"></span> {{ company.getNbPerson() }}</p>
              <p class="address"><span class="lnr lnr-map"></span> {{ company.getCity() }}, {{ company.getCountry() }}
              </p>
              <h5> <a routerLink="/admin/offres-emploi/{{ company.getId() }}" style="color: #3f3f8e;">{{
                  company.getNbJobs() }} offres d'emploi</a></h5>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </section>
  <!-- End post Area -->

  <!-- <app-call-to-action></app-call-to-action> -->

</section>